module.exports = __webpack_public_path__ + "static/media/TrelloRD.926f0b48.png";